import { createSlice } from "@reduxjs/toolkit";

interface LeaveInformationInterface {
    isTimeoutModalOpen: boolean;
}

const initialState: LeaveInformationInterface = {
    isTimeoutModalOpen: false,
};

const LeaveInformationSlice = createSlice({
    name: "leaveInformation",
    initialState,
    reducers: {
        setIsTimeoutModalOpen: (state, action) => {
            state.isTimeoutModalOpen = action.payload;
        },
    },
});

export const leaveInformationReducer = LeaveInformationSlice.reducer;
export const { setIsTimeoutModalOpen } = LeaveInformationSlice.actions;
